import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=3bdcb31a&scoped=true"
import script from "./Classroom.vue?vue&type=script&lang=js"
export * from "./Classroom.vue?vue&type=script&lang=js"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=3bdcb31a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcb31a",
  null
  
)

export default component.exports